import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { ListFormBase } from '../../../core/helper/ListFormBase';
import { MatDialog } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';
import { AppAttendance, AppAttendanceSummary } from '../../../core/models/appAttendace.model';
import { AppAttendanceService } from '../../../core/services/appAttendanceService.service';
import { EditMarcajesDialog } from '../edit-marcajes-dialog/edit-marcajes-dialog.component';
import { EditMarcajesSummaryDialog } from '../edit-marcajes-summary-dialog/edit-marcajes-summary-dialog.component';
import { MarcajeCoordinatesDialog } from '../marcaje-coordinates-dialog/marcaje-coordinates-dialog.component';
import { adjustTimeToSystemTimezone } from '../../helpers/getLocalDate.js';
import { formatDate, formatDateToTime } from '../../helpers/getIsoStringDate.js';
import { LicenseCheckerService } from '../../../core/helper/licenseChecker';
import { MarcajeExportDialog } from '../marcaje-export-dialog/marcaje-export-dialog.component';

import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from "xlsx-js-style"
import { LivesSessionHelper } from '../../../core/helper/livesSessionHelper';
import { SessionHelper } from '../../../core/helper/sessionHelper';


@Component({
  selector: 'app-marcajes-list',
  templateUrl: './marcajes-list.component.html',
  styleUrls: ['./marcajes-list.component.scss'],
  providers: []
})
export class MarcajesListComponent extends ListFormBase<AppAttendance> implements AfterViewInit {

  private isAutomaticChange: boolean = false;
  conectiaLicence: boolean = false;

  constructor(
    protected _modelService: AppAttendanceService,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _messageDialog: MessageDialog,
    protected _editMarcajesDialog: MatDialog,
    protected _editMarcajesSummaryDialog: MatDialog,
    protected _exportMarcajesDialog: MatDialog,
    protected appAttendanceService: AppAttendanceService,
    private cdr: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public _licenceCheckerService: LicenseCheckerService,
    public _livesSession: LivesSessionHelper,
    public _session: SessionHelper

  ) {
    super(_modelService, _router, _route, _messageDialog, AppAttendance);
    this.isCrud = true;

    this.conectiaLicence = this._licenceCheckerService.checkLicense("conectia");

    // Cargar filtros desde localStorage y crear varibables para obtener la semana acual
    const storedFilterStart = localStorage.getItem('filterStart');
    const storedFilterEnd = localStorage.getItem('filterEnd');
    const storedCompany = localStorage.getItem('company');
    const storedCostCenter = localStorage.getItem('costCenter');
    const now = new Date();
    const dayOfWeek = now.getDay();
    const startOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
    const daysUntilSunday = 7 - dayOfWeek;



    if (storedFilterStart || storedFilterEnd) {
      // Si existen, aplicarlos desde el localStorage
      if (storedFilterStart) { this.filterStart = storedFilterStart === "null" ? null : new Date(storedFilterStart); }
      if (storedFilterEnd) { this.filterEnd = storedFilterEnd === "null" ? null : new Date(storedFilterEnd); }

    } else {
      this.isAutomaticChange = true;
      // Si no existen, inicializar con lunes a domingo de la semana actual y guardar en localStorage
      this.filterStart = new Date(now);
      this.filterStart.setDate(now.getDate() + startOffset);

      this.filterEnd = new Date(this.filterStart);
      this.filterEnd.setDate(this.filterStart.getDate() + 6);
      this.isAutomaticChange = false;

    }
    // Mostrar y guardar empresa
    this.company = storedCompany !== null ? (storedCompany === "null" ? null : storedCompany) : null;
    localStorage.setItem('company', this.company);

    // Mostrar 
    this.filterCostCenter = storedCostCenter !== null ? JSON.parse(localStorage.getItem('costCenter')) : null;

    // Calcular el máximo de fecha seleccionable
    this.maxDate = new Date(now);
    this.maxDate.setDate(now.getDate() + daysUntilSunday);
    this.maxDate.setHours(23, 59, 59, 999);
  }

  panelIcon = 'user-clock';
  panelTitle = 'Marcajes';
  panelDescription = 'Listado de Marcajes';
  environmentID = this._livesSession.EnvironmentId;
  now: Date = new Date();
  exporting = false;

  dataSource0: AppAttendanceSummary[] = [];
  @ViewChild('dataGrid0') dataGrid0: any;
  dataSource1: AppAttendance[] = [];
  @ViewChild('dataGrid1') dataGrid1: any;

  view: string = '0'; /* 0 POR DÍA | 1 POR REGISTRO */
  company: any;
  companyName: any;
  filterStart: Date;
  filterEnd: Date;
  filterCostCenter: { imputationCode?: string, company1?: string, companyCode?: number, environment?: string };
  maxDate: Date;

  private currentTaskId0: number = 0; // Contador para loadData0
  private currentTaskId1: number = 0; // Contador para loadData1

  ngAfterViewInit(): void {
    this.loadData0()
    this.loadData1()
  }

  openPDF() {
    const url = "http://liveshr.com/wp-content/uploads/2024/12/Marcajes-Funcionalidad-Usuario.pdf";
    window.open(url, "_blank");
  }

  onTabChange(index: number): void {
    setTimeout(() => {
      if (index === 0 && this.dataGrid0?.instance) {
        this.view = index.toString();
        this.loadData0()
        this.dataGrid0.instance.refresh();
      } else if (index === 1 && this.dataGrid1?.instance) {
        this.dataGrid1.instance.refresh();
        this.loadData1();
        this.view = index.toString();
      }
    }, 100); // Pequeño retraso para garantizar que el DOM esté completamente cargado
  }

  onToolbarPreparing(e: any): void {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'exportpdf',
        onClick: () => this.view === '0' ? this.exportToPDFDaily() : this.exportToPDF(),
        // onClick: () => this.view === '0' ? this.exportToPDFDaily() : this.exportToPDF(),
      },
    });
  }

  onRowPrepared0(event: any) {
    if (event.rowType === 'data' && !event.data.valid) {
      event.rowElement.style.setProperty('background-color', '#ffdcdc', 'important');
      event.rowElement.style.setProperty('transition', 'background-color 0.2s ease', 'important');
      event.rowElement.classList.remove('dx-row-alt');
    }
  }

  async loadData0(): Promise<void> {
    const taskId = ++this.currentTaskId0; // Incrementar solo para esta tarea

    try {
      if (this.dataGrid0?.instance) {
        this.dataGrid0.instance.beginCustomLoading('');
      }

      const dateFrom = this.filterStart ? formatDate(this.filterStart.toUTCString(), false, false) : undefined;
      const dateTo = this.filterEnd ? formatDate(this.filterEnd.toUTCString(), false, false) : undefined;


      this._modelService.getAllModelsAttendanceGrouped(
        this.company,
        dateFrom,
        dateTo,
        this.filterCostCenter?.imputationCode,
        this.filterCostCenter?.company1,
        this.filterCostCenter?.companyCode,
        this.filterCostCenter?.environment
      ).subscribe({
        next: (records) => {
          // Validar que esta tarea aún es relevante
          if (taskId !== this.currentTaskId0) {
            return;
          }

          // Procesar los resultados
          this.dataSource0 = records.summaries ? [] : Object.values(records);
        },
        error: (error) => {
          console.error('Error al cargar los datos registros por día:', error);
        },
        complete: () => {
        },
      });
    } catch (error) {
      console.error('Error general en loadData0:', error);
    } finally {
      if (this.dataGrid0?.instance) {
        this.dataGrid0.instance.endCustomLoading();
      }
    }
  }





  onClickCheck0(e) {
    const dialogRef = this._editMarcajesSummaryDialog.open(EditMarcajesSummaryDialog, {
      width: '100%',
      data: e
    });

    const dialogContainer = this.document.querySelector('.mat-dialog-container');
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    dialogRef.afterClosed().subscribe(result => {
      this.loadData0();
    });
  }

  onExporting0(e) {
    e.cancel = true;

    const childDialog = this._exportMarcajesDialog.open(MarcajeExportDialog, {
      width: '50%'
    });

    const dialogContainer = this.document.querySelectorAll('.mat-dialog-container')[0];
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    childDialog.afterClosed().subscribe(result => {
      if (result) {
        const { disabled } = result;
        const dataSource = this.dataSource0;
        const sortedData = dataSource.sort((a, b) => new Date(b.day).getTime() - new Date(a.day).getTime());

        const filteredData = sortedData.map(item => {
          const sortedRecords = [...item.records]
            .filter(record => disabled || record.enabled)
            .sort((a, b) => new Date(a.attendanceAt).getTime() - new Date(b.attendanceAt).getTime());

          const firstEntry = sortedRecords.find(record => record.typeData?.entry === true);
          const firstExit = sortedRecords.find(record => record.typeData?.entry === false);
          const secondEntry = sortedRecords.filter(record => record.typeData?.entry === true)[1];
          const secondExit = sortedRecords.filter(record => record.typeData?.entry === false)[1];

          const getTime = (record: any) => record?.localAttendanceAt ?? record?.attendanceAt ?? '';

          return {
            'Estado': item.valid ? 'Válido' : 'No válido',
            'Día': formatDate(item.localDay ?? item.day, false, true, true),
            'Empresa': item.companyData?.name || '',
            'Empleado': item.userData?.fullName || '',

            '1ª Entrada': firstEntry ? formatDate(getTime(firstEntry), true, true, true) : '---',
            'Zona Horaria 1ª Entrada': firstEntry?.localAttendanceAt ? (firstEntry.timeZone ?? '') : '',

            '1ª Salida': firstExit ? formatDate(getTime(firstExit), true, true, true) : '---',
            'Zona Horaria 1ª Salida': firstExit?.localAttendanceAt ? (firstExit.timeZone ?? '') : '',

            '2ª Entrada': secondEntry ? formatDate(getTime(secondEntry), true, true, true) : '---',
            'Zona Horaria 2ª Entrada': secondEntry?.localAttendanceAt ? (secondEntry.timeZone ?? '') : '',

            '2ª Salida': secondExit ? formatDate(getTime(secondExit), true, true, true) : '---',
            'Zona Horaria 2ª Salida': secondExit?.localAttendanceAt ? (secondExit.timeZone ?? '') : '',
            'Total Horas': item.totalHours || ''
          };
        });

        this.exportToExcel(filteredData, this.generateExportFileName0());

      }
    });
  }

  generateExportFileName0(): string {
    const companyPart = this.companyName ? `(${this.companyName})` : '';
    const startDatePart = this.filterStart ? `(desde_${this.formatExportNameDate(this.filterStart)})` : '';
    const endDatePart = this.filterEnd ? `(hasta_${this.formatExportNameDate(this.filterEnd)})` : '';

    return `Listado_Registros_por_Dia_LivesHR${companyPart}${startDatePart}${endDatePart}`;
  }

  onRowPrepared1(event: any) {
    if (event.rowType === 'data' && !event.data.valid) {
      event.rowElement.style.setProperty('background-color', '#ffdcdc', 'important');
      event.rowElement.style.setProperty('transition', 'background-color 0.2s ease', 'important');
      event.rowElement.classList.remove('dx-row-alt');
    }
  }

  async loadData1(): Promise<void> {
    const taskId = ++this.currentTaskId1; // Incrementar solo para esta tarea

    try {
      if (this.dataGrid1?.instance) {
        this.dataGrid1.instance.beginCustomLoading('');
      }

      const dateFrom = this.filterStart ? formatDate(this.filterStart.toUTCString(), false, false) : undefined;
      const dateTo = this.filterEnd ? formatDate(this.filterEnd.toUTCString(), false, false) : undefined;


      this._modelService.getAllModelsAttendance(
        this.company,
        dateFrom,
        dateTo,
        this.filterCostCenter?.imputationCode,
        this.filterCostCenter?.company1,
        this.filterCostCenter?.companyCode,
        this.filterCostCenter?.environment
      ).subscribe({
        next: (records) => {
          // Validar que esta tarea aún es relevante
          if (taskId !== this.currentTaskId1) {
            return;
          }

          // Procesar los resultados
          this.dataSource1 = records.records ? [] : Object.values(records);
        },
        error: (error) => {
          console.error('Error al cargar los datos registros:', error);
        },
        complete: () => {
        },
      });
    } catch (error) {
      console.error('Error general en loadData1:', error);
    } finally {
      if (this.dataGrid1?.instance) {
        this.dataGrid1.instance.endCustomLoading();
      }
    }
  }

  onClickToggleValid1(data: any): void {
    this._messageDialog.showQuestionInput(
      `Se ${data.data.valid ? `marcará el registro como NO válido` : `marcará el registro como válido`}`,
      `${data.data.valid ? 'Marcar como NO válido' : 'Marcar como válido'}`,
      data.data.notes ? data.data.notes : '',
      "Nota"
    )
      .then(result => {
        if (result.isConfirmed) {  // Notas no obligatorias
          data.data.notes = result.value !== undefined ? result.value : '';  // Asignar cadena vacía si result.value es ''

          this.appAttendanceService.toggleValid({ id: data.data.attendanceRecord1, data: data.data }).subscribe(
            (response) => {
            },
            (error) => {
              console.error('Error al editar:', error);
            }
          );
          data.data.valid = !data.data.valid;
          this.cdr.detectChanges();
        }
      });
  }

  onClickToggleEnable1(data: any): void {
    this._messageDialog.ShowQuestion(

      `Se ${data.data.enabled ? `deshabilitará el registro, no será visible para el empleado ni será válido para el recuento de horas` : `habilitará  el registro, será visible para el empleado y será válido para el recuento de horas`}`,
      `${data.data.enabled ? 'Deshabilitar' : 'Habilitar'}`

    )
      .then(result => {
        if (result.value) {
          this.appAttendanceService.toggleEnabled({ id: data.data.attendanceRecord1, data: data.data }).subscribe(
            (response) => {
            },
            (error) => {
              console.error('Error al editar:', error);
            }
          );
          data.data.enabled = !data.data.enabled;
          this.cdr.detectChanges();
        }
      });
  }


  onClickAdd1() {
    const dialogRef = this._editMarcajesDialog.open(EditMarcajesDialog, {
      width: '100%',
      data: null,
    });

    const dialogContainer = this.document.querySelector('.mat-dialog-container');
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    dialogRef.afterClosed().subscribe(result => {
      this.loadData1();
    });
  }

  onClickCheck1(e) {
    const dialogRef = this._editMarcajesDialog.open(EditMarcajesDialog, {
      width: '100%',
      data: e,
    });

    const dialogContainer = this.document.querySelector('.mat-dialog-container');
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  onLocationCheck(e) {

    const dialogRef = this._editMarcajesDialog.open(MarcajeCoordinatesDialog, {
      width: '100%',
      data: e,
    });

    const dialogContainer = this.document.querySelector('.mat-dialog-container');
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  onExporting1(e) {
    e.cancel = true;

    const childDialog = this._exportMarcajesDialog.open(MarcajeExportDialog, {
      width: '50%'
    });

    const dialogContainer = this.document.querySelectorAll('.mat-dialog-container')[0];
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    childDialog.afterClosed().subscribe(result => {
      if (result) {
        const { disabled } = result;
        // Obtener la fuente de datos con los filtros actuales
        const dataSource = this.dataSource1;
        // Ordenar los datos al revés
        const sortedRecords = dataSource.sort((a, b) => new Date(b.attendanceAt).getTime() - new Date(a.attendanceAt).getTime());

        // Filtrar y formatear los datos
        const filteredData = sortedRecords
          .filter(item => disabled || item.enabled) // Si disabled es true, muestra todos; si es false, solo los habilitados
          .map(item => ({
            Estado: item.valid ? 'Válido' : 'No válido',
            Día: formatDate(item.localAttendanceAt ?? item.attendanceAt, false, true, true),
            Empresa: item.companyData?.name || '',
            Empleado: item.userData?.fullName || '',
            'Hora Marcaje': item.attendanceAt ? formatDateToTime(item.localAttendanceAt ?? item.attendanceAt) : '',
            'Zona Horaria': item.timeZone ?? '',
            Tipo: item.typeData?.name || '',
            Origen: item.source == 'WEB' ? 'MANUAL' : item.source,
            Centro: item.workCenterData?.name || '',
            Localización: item.coordinates || 'Sin localización'
          }));


        // Exportar a Excel
        this.exportToExcel(filteredData, this.generateExportFileName1());

      }
    });
  }

  generateExportFileName1(): string {
    const companyPart = this.companyName ? `(${this.companyName})` : '';
    const startDatePart = this.filterStart ? `(desde_${this.formatExportNameDate(this.filterStart)})` : '';
    const endDatePart = this.filterEnd ? `(hasta_${this.formatExportNameDate(this.filterEnd)})` : '';

    return `Listado_Registros_LivesHR${companyPart}${startDatePart}${endDatePart}`;
  }


  viewSelectedChanged(e) {
    this.view = e;
    this.loadData0();
    this.loadData1();
  }

  companySelectedChanged(e) {

    const selectedId = Array.isArray(e) ? e[0]?.id : e;

    if (e === undefined) {
      this.company = null
      localStorage.setItem('company', this.company);

    } else if (selectedId !== this.company) {
      this.company = selectedId;
      this.companyName = e[0].name;
      localStorage.setItem('company', selectedId);
    }

    this.checkFilters(true);
  }

  costCenterSelectedChanged(e) {

    if (e === undefined) {
      localStorage.removeItem('costCenter');
      this.filterCostCenter = {}
      this.checkFilters(false);

    } else if (e.imputationCode) {
      let costCenterToLocalStorage = {
        imputationCode: e.imputationCode,
        company1: e.company1,
        companyCode: e.companyCode,
        environment: e.environment,
      };

      localStorage.setItem('costCenter', JSON.stringify(costCenterToLocalStorage));
      this.checkFilters(false);
    }
  }

  onDateStartChange(e) {
    this.filterStart = e.value;

    if (!this.isAutomaticChange && e.value) {
      localStorage.setItem('filterStart', e.value.toISOString());
    }

    this.loadData0();
    this.loadData1();
  }

  onDateEndChange(e) {
    this.filterEnd = e.value;

    if (!this.isAutomaticChange && e.value) {
      localStorage.setItem('filterEnd', e.value.toISOString());
    }

    this.loadData0();
    this.loadData1();
  }

  onResetFilters() {
    this.filterEnd = null;
    this.filterStart = null;
    this.company = null;
    this.companyName = null;
    this.filterCostCenter = {};

    // Eliminar los valores de los filtros en localStorage
    localStorage.removeItem('filterStart'); //Elimino del todo para que obtenga como filtro la semana actual
    localStorage.removeItem('filterEnd'); //Elimino del todo para que obtenga como filtro la semana actual
    localStorage.setItem('company', 'null');
    localStorage.removeItem('costCenter');

    this.loadData0();
    this.loadData1();

  }

  async checkFilters(companyChanged: boolean): Promise<void> {
    const company = localStorage.getItem('company');
    const costCenter = localStorage.getItem('costCenter');
    const parsedCostCenter = costCenter ? JSON.parse(costCenter) : null;
    const previousFilters = { ...this.filterCostCenter, company: this.company };


    if (this.conectiaLicence && parsedCostCenter) {
      if (companyChanged) {
        if (company !== parsedCostCenter.company1) {
          this.filterCostCenter = {};
        }
      } else {
        if (company !== parsedCostCenter?.company1) {
          this.company = parsedCostCenter.company1;
          localStorage.setItem('company', parsedCostCenter.company1);
        }

        if (
          this.filterCostCenter.imputationCode !== parsedCostCenter?.imputationCode ||
          this.filterCostCenter.company1 !== parsedCostCenter?.company1 ||
          this.filterCostCenter.companyCode !== parsedCostCenter?.companyCode ||
          this.filterCostCenter.environment !== parsedCostCenter?.environment
        ) {
          this.filterCostCenter = parsedCostCenter;
        }
      }
    }


    const currentFilters = { ...this.filterCostCenter, company: this.company };
    if (JSON.stringify(previousFilters) !== JSON.stringify(currentFilters)) {
      this.currentTaskId0++;
      this.currentTaskId1++;
    }

    // Llamar a las funciones de carga de datos de forma segura
    await this.loadData0();
    await this.loadData1();
  }




  formatExportNameDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}_${month}_${year}`;
  }

  showYesOrNo = (data: any): string => {
    return data.valid ? 'Sí' : 'No';
  };

  adjustAttendanceDate(rowData: any) {
    const adjustedDate = adjustTimeToSystemTimezone(rowData.attendanceAt);
    return new Date(rowData.localAttendanceAt ?? adjustedDate.iso);
  }

  adjustAttendanceTime(rowData: any) {
    const adjustedDate = adjustTimeToSystemTimezone(rowData.attendanceAt);
    return rowData.localAttendanceAt
      ? formatDateToTime(rowData.localAttendanceAt)
      : adjustedDate.time;
  }

  adjustAttendanceSummaryDate(rowData: any) {
    const adjustedDate = adjustTimeToSystemTimezone(rowData.day);
    return new Date(rowData.localDay ?? adjustedDate.iso);
  }

  adjustAttendanceSummaryFirstEntryTime(rowData: any) {
    const adjustedDate = adjustTimeToSystemTimezone(rowData.firstEntryTime);

    return rowData.firstEntryLocalTime
      ? formatDateToTime(rowData.firstEntryLocalTime)
      : adjustedDate.time;
  }

  adjustAttendanceSummaryLastExitTime(rowData: any) {
    const adjustedDate = adjustTimeToSystemTimezone(rowData.lastExitTime);
    return rowData.lastExitLocalTime
      ? formatDateToTime(rowData.lastExitLocalTime)
      : adjustedDate.time;
  }

  formatTimeValue = (data) => {
    if (data.totalHours) {
      return data.totalHours.split(".")[0];
    }
    return '';
  };

  formatCoordinates(rowData: any) {
    return rowData.coordinates ? rowData.coordinates : 'Sin localización';
  }

  getStatusColor(valid: boolean): string {
    return valid ? '#4caf50' : '#f44336'; // Verde para válido, rojo para no válido
  }

  getIconForStatus(valid: boolean): [string, string] {
    return valid ? ['fas', 'check'] : ['fas', 'times'];
  }

  getIconForSource(source: string): [string, string] {
    return source === 'APP' ? ['fas', 'mobile-alt'] : ['fas', 'hand-paper'];
  }

  formatSource(data: any): string {
    return data.source === 'WEB' ? 'MANUAL' : data.source;
  }

  exportToPDFDaily(): void {
    const childDialog = this._exportMarcajesDialog.open(MarcajeExportDialog, {
      width: '50%'
    });

    const dialogContainer = this.document.querySelectorAll('.mat-dialog-container')[0];
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    childDialog.afterClosed().subscribe(result => {
      if (result) {
        const { disabled } = result;

        const doc = new jsPDF({ orientation: 'landscape' });
        const now = new Date();
        const localTime = formatDate(now.toISOString(), true, true, true);
        const utcTime = formatDate(now.toISOString(), true, true, true, true) + ' (UTC)';
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const creationDateDisplay = `${localTime} (${timeZone}) - ${utcTime}`; // Fecha y hora
        let pageCount = 0; // Contador de páginas

        const combinedFilter = this.dataGrid0.instance.getCombinedFilter();
        const filteredDataSource = this.dataGrid0.instance.getDataSource().store()
          .load({ filter: combinedFilter })
          .then((filteredData) => {

            // Ordenar los datos de más nuevo a más viejo
            const sortedData = [...filteredData].sort((a, b) => new Date(b.day).getTime() - new Date(a.day).getTime());


            // Obtener el usuario desde el session
            const userName = `${this._session.User.Name || 'Usuario'} ${this._session.User.Surname || ''}`.trim();

            // Agregar el texto en el pie de página
            const addFooter = () => {
              const pageHeight = doc.internal.pageSize.height;
              const pageWidth = doc.internal.pageSize.width;
              pageCount++;
              doc.setFontSize(8); // Tamaño pequeño para el pie de página
              doc.text(`Generado por ${userName} el: ${creationDateDisplay}`, 10, pageHeight - 10); // Fecha y hora 
              doc.text(`Página ${pageCount}`, pageWidth - 50, pageHeight - 10); // Número de página
            };

            // Ruta y tamaño de la imagen
            const imgPath = 'assets/img/livesHR-good-color.png';
            const imgWidth = 20; // Imagen más pequeña
            const imgHeight = 10;
            const imgX = doc.internal.pageSize.width - imgWidth - 5; // Más pegada a la esquina derecha
            const imgY = 3; // Más cerca del borde superior

            // Cargar la imagen como base64
            const imagePromise = fetch(imgPath)
              .then(res => res.blob())
              .then(blob => {
                const reader = new FileReader();
                return new Promise<string>((resolve) => {
                  reader.onloadend = () => resolve(reader.result as string);
                  reader.readAsDataURL(blob);
                });
              });

            imagePromise.then((imgBase64) => {
              // Función para añadir la imagen en todas las páginas
              const addHeaderImage = () => {
                doc.addImage(imgBase64, 'PNG', imgX, imgY, imgWidth, imgHeight);
              };

              // Añadir la imagen en la primera página
              addHeaderImage();

              // Título principal
              doc.setFontSize(12); // Tamaño reducido del título principal
              doc.text('Reporte de Asistencia', 10, 20);


              const tableData = sortedData.map(item => {
                // Ordenar los registros por fecha
                const sortedRecords = [...item.records].filter(item => disabled || item.enabled).sort((a, b) => new Date(a.attendanceAt).getTime() - new Date(b.attendanceAt).getTime());

                // Extraer entradas y salidas
                const firstEntry = sortedRecords.find(record => record.typeData?.entry === true);
                const firstExit = sortedRecords.find(record => record.typeData?.entry === false);
                const secondEntry = sortedRecords.filter(record => record.typeData?.entry === true)[1];
                const secondExit = sortedRecords.filter(record => record.typeData?.entry === false)[1];

                const getTime = (record: any) => record?.localAttendanceAt ?? record?.attendanceAt ?? '';
                const getZone = (record: any) => record?.localAttendanceAt ? ` (${record?.timeZone})` : '';


                return [
                  item.valid ? 'Válido' : 'No válido',
                  formatDate(item.localDay ?? item.day, false, true, true),
                  item.companyData?.name || '',
                  item.userData?.fullName || '',
                  firstEntry ? formatDate(getTime(firstEntry), true, true, true) + getZone(firstEntry) : '---',
                  firstExit ? formatDate(getTime(firstExit), true, true, true) + getZone(firstExit) : '---',
                  secondEntry ? formatDate(getTime(secondEntry), true, true, true) + getZone(secondEntry) : '---',
                  secondExit ? formatDate(getTime(secondExit), true, true, true) + getZone(secondExit) : '---',
                  item.totalHours || '',
                ];
              });

              autoTable(doc, {
                head: [['Estado', 'Día', 'Empresa', 'Empleado', '1ª Entrada', '1ª Salida', '2ª Entrada', '2ª Salida', 'Total Horas']],
                body: tableData,
                startY: 30, // Ajustar para que no se sobreponga con la imagen
                styles: { fontSize: 10 }, // Tamaño de texto más pequeño en la tabla
                didDrawPage: () => {
                  addHeaderImage(); // Añadir la imagen en todas las páginas
                  addFooter(); // Añadir pie de página
                },
              });

              // Agregar registros tabulados por cada día
              /* sortedData.forEach((item, index) => {
                doc.addPage(); // Siempre añade una nueva página para los registros
       
                // Título reducido con el empleado
                doc.setFontSize(10); // Tamaño pequeño para el título
                doc.text(
                  `Registros del día: ${formatDate(item.day, false, true, true)} - Empleado: ${item.userData.fullName}`,
                  10,
                  20
                );
       
                const recordsData = item.records.map(record => [
                  formatDate(record.attendanceAt, true, true, true) || '',
                  record.typeData?.name || '',
                  record.workCenterData?.name || '',
                  record.source === 'WEB' ? 'MANUAL' : record.source || '',
                  record.valid ? 'Válido' : 'No válido',
                  record.workCenterData?.coordinates || 'Sin localización',
                ]);
       
                autoTable(doc, {
                  head: [['Hora (UTC)', 'Tipo', 'Centro de trabajo', 'Origen', 'Validez', 'Localización (Coordenadas)']],
                  body: recordsData,
                  startY: 30, // Ajustar para que no se sobreponga con la imagen
                  styles: { fontSize: 10 }, // Tamaño de texto más pequeño en las tablas
                  didDrawPage: () => {
                    addHeaderImage(); // Añadir la imagen en todas las páginas
                    addFooter(); // Añadir pie de página
                  },
                });
              }); */

              // Guarda el PDF
              doc.save(this.generateReportFileName());
            });
          })
      }
    })
  }

  exportToPDF(): void {

    const childDialog = this._exportMarcajesDialog.open(MarcajeExportDialog, {
      width: '50%'
    });

    const dialogContainer = this.document.querySelectorAll('.mat-dialog-container')[0];
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    childDialog.afterClosed().subscribe(result => {
      if (result) {
        const { disabled } = result;


        const doc = new jsPDF({ orientation: 'landscape' });
        const now = new Date();
        const localTime = formatDate(now.toISOString(), true, true, true);
        const utcTime = formatDate(now.toUTCString(), true, true, true, true) + ' (UTC)';
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const creationDateDisplay = `${localTime} (${timeZone}) -  ${utcTime}`; // Fecha y hora
        let pageCount = 0; // Contador de páginas

        const combinedFilter = this.dataGrid1.instance.getCombinedFilter();
        const filteredDataSource = this.dataGrid1.instance.getDataSource().store()
          .load({ filter: combinedFilter })
          .then((filteredData) => {

            // Ordenar los datos de más nuevo a más viejo
            const sortedData = [...filteredData].filter(item => disabled || item.enabled).sort((a, b) => new Date(b.attendanceAt).getTime() - new Date(a.attendanceAt).getTime());

            // Obtener el usuario desde el session
            const userName = `${this._session.User.Name || 'Usuario'} ${this._session.User.Surname || ''}`.trim();

            // Agregar el texto en el pie de página
            const addFooter = () => {
              const pageHeight = doc.internal.pageSize.height;
              const pageWidth = doc.internal.pageSize.width;
              pageCount++;
              doc.setFontSize(8); // Tamaño pequeño para el pie de página
              doc.text(`Generado por ${userName} el: ${creationDateDisplay}`, 10, pageHeight - 10); // Fecha y hora 
              doc.text(`Página ${pageCount}`, pageWidth - 50, pageHeight - 10); // Número de página
            };


            // Ruta y tamaño de la imagen
            const imgPath = 'assets/img/livesHR-good-color.png';
            const imgWidth = 20; // Imagen más pequeña
            const imgHeight = 10;
            const imgX = doc.internal.pageSize.width - imgWidth - 5; // Más pegada a la esquina derecha
            const imgY = 3; // Más cerca del borde superior

            // Cargar la imagen como base64
            const imagePromise = fetch(imgPath)
              .then(res => res.blob())
              .then(blob => {
                const reader = new FileReader();
                return new Promise<string>((resolve) => {
                  reader.onloadend = () => resolve(reader.result as string);
                  reader.readAsDataURL(blob);
                });
              });

            imagePromise.then((imgBase64) => {
              // Función para añadir la imagen en todas las páginas
              const addHeaderImage = () => {
                doc.addImage(imgBase64, 'PNG', imgX, imgY, imgWidth, imgHeight);
              };

              // Añadir la imagen en la primera página
              addHeaderImage();

              // Título principal
              doc.setFontSize(12); // Tamaño reducido del título principal
              doc.text('Reporte Detallado de Asistencia', 10, 20);


              const tableData = sortedData.map(item => [
                item.valid ? 'Válido' : 'No válido', // Validez
                item.localAttendanceAt ? formatDate(item.localAttendanceAt, true, true, true) + ` (${item.timeZone})` : formatDate(item.attendanceAt, true, true, true) ?? '---', //Fecha de registro
                item.companyData?.name || '---', // Empresa
                item.userData?.fullName || '---', // Empleado
                item.typeData?.name || '---', // Tipo (entrada/salida)
                item.workCenterData?.name || '---', // Centro de trabajo
                item.source === 'WEB' ? 'MANUAL' : item.source || '---', // Origen
                item.workCenterData?.coordinates || 'Sin coordenadas', // Coordenadas
                item.enabled ? 'Habilitado' : 'Deshabilitado', // Habilitado
              ]);

              autoTable(doc, {
                head: [['Estado', 'Fecha registro', 'Empresa', 'Empleado', 'Tipo', 'Centro de Trabajo', 'Origen', 'Coordenadas', 'Habilitado']],
                body: tableData,
                startY: 30, // Ajustar para que no se sobreponga con la imagen
                styles: { fontSize: 10 }, // Tamaño de texto más pequeño en la tabla
                didDrawPage: () => {
                  addHeaderImage(); // Añadir la imagen en todas las páginas
                  addFooter(); // Añadir pie de página
                },
              });

              // Guarda el PDF
              doc.save(this.generateReportFileName());
            });
          })
      }
    })
  }

  generateReportFileName(): string {
    const companyPart = this.companyName ? `(${this.companyName})` : '';
    const startDatePart = this.filterStart ? `(desde_${this.formatExportNameDate(this.filterStart)})` : '';
    const endDatePart = this.filterEnd ? `(hasta_${this.formatExportNameDate(this.filterEnd)})` : '';
    const baseText = this.view === '0' ? 'Reporte_Registros_Por_Dia_LivesHR' : 'Reporte_Registros_LivesHR'

    return `${baseText}${companyPart}${startDatePart}${endDatePart}`;
  }

  exportToExcel(data: any[], fileName: string): void {
    const worksheet = XLSX.utils.json_to_sheet(data, {
      header: Object.keys(data[0] || {}),
      skipHeader: false
    });

    // Aplicar estilos a la cabecera y alinear todas las columnas al centro
    const headerRange = XLSX.utils.decode_range(worksheet['!ref']);
    for (let row = headerRange.s.r; row <= headerRange.e.r; row++) {
      for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
        if (!worksheet[cellAddress]) continue;
        worksheet[cellAddress].s = {
          font: { bold: row === 0, color: { rgb: "000000" } },
          alignment: { horizontal: "center" },
          border: row === 0 ? { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } : {}
        };
      }
    }

    // Ajustar el ancho de las columnas al contenido más largo
    const colWidths = Object.keys(data[0] || {}).map((key, index) => ({ wch: Math.max(...data.map(row => (row[key] ? row[key].toString().length : 0)), key.length) + 2 }));
    worksheet['!cols'] = colWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Marcajes");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  }

  getInvalidSummaryTooltip(errors: string[]): string {
    const tooltip = errors.join('\n'); // Concatena con saltos de línea.

    return tooltip;
  }

  getInvalidRecordTooltip(error: string): string {
    const tooltip = `${error}`

    return tooltip;
  }

}
